module.exports = __webpack_public_path__ + "img/mailbox.330eeb62.png";